import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getCashback = (params) => {
    return axios.get(`${backendHost}/api/admin/cashback`, {params});
};